<template>
  <div id="myDIV" class="font-nunito text-base text-black dark:text-white dark:bg-slate-900 mt-[74px]">
    <nav-bar-component />
    <payment-component />
    <testimonial-component />
    <sponsors-component />
    <footer-component />
    <back-to-top-component />
  </div>
</template>

// @ is an alias to /src
<script>
// import { UisStar } from '@iconscout/vue-unicons-solid';
// import { UilVuejs } from '@iconscout/vue-unicons';
import Tailwind from "../assets/css/tailwind.css";
import AddStyle from "../assets/css/add-style.css";

import NavBarComponent from "@/components/NavBarComponent.vue";
import SponsorsComponent from "@/components/SponsorsComponent.vue";
import AboutComponent from "@/components/AboutComponent.vue";
import AboutCompanyComponent from "@/components/AboutCompanyComponent.vue";
import PricingComponent from "@/components/PricingComponent.vue";
import PricingHostingComponent from "@/components/PricingHostingComponent.vue";
import DataLineComponent from "@/components/DataLineComponent.vue";
import FooterComponent from "@/components/footerComponent.vue";
import StepTreatComponent from "@/components/StepTreatComponent.vue";
import AboutCompanyComponentNext from "@/components/AboutCompanyComponentNext.vue";
import BackToTopComponent from "@/components/BackToTopComponent.vue";
import TestimonialComponent from "@/components/TestimonialComponent.vue";
import PaymentComponent from "@/components/paymentComponent.vue";
export default {
  name: "HomeView",
  components: {
    // UisStar,
    //UilVuejs,
    Tailwind,
    AddStyle,
    NavBarComponent,
    SponsorsComponent,
    AboutComponent,
    AboutCompanyComponent,
    PricingComponent,
    PricingHostingComponent,
    DataLineComponent,
    FooterComponent,
    StepTreatComponent,
    AboutCompanyComponentNext,
    BackToTopComponent,
    TestimonialComponent,
    PaymentComponent,
  },
  beforeMount() {
    this.topFunction();
  },
  methods: {
    topFunction() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped></style>
